/* STRYKR CRO #5 — Galerie swipe + zoom (non-invasif)
   Réutilise la logique existante : le swipe et la lightbox déclenchent les
   flèches .gal-nav. Aucun état de galerie dupliqué. */
/* STRYKR LIGHTBOX NAVIGATION 20260716 */
(function () {
  function init() {
    var frame = document.querySelector('.strykr-page .main-frame#main-frame');
    if (!frame || frame.dataset.swipeZoom) return;
    frame.dataset.swipeZoom = '1';

    var root = frame.closest('.strykr-page');
    var handle = root && root.dataset.productHandle;
    var enhanced =
      handle === 'die-taktische-hose' ||
      handle === 'strykr-einsatzhose-pro' ||
      handle === 'strykr-guertel';
    var right = root && root.querySelector('.gal-nav.right');
    var left = root && root.querySelector('.gal-nav.left');

    /* --- SWIPE GALERIE : réutilise les flèches existantes --- */
    var x0 = null;
    var y0 = null;
    frame.addEventListener('touchstart', function (event) {
      if (event.touches.length !== 1) {
        x0 = y0 = null;
        return;
      }
      x0 = event.touches[0].clientX;
      y0 = event.touches[0].clientY;
    }, { passive: true });
    frame.addEventListener('touchend', function (event) {
      if (x0 === null || !event.changedTouches.length) return;
      var deltaX = event.changedTouches[0].clientX - x0;
      var deltaY = event.changedTouches[0].clientY - y0;
      if (Math.abs(deltaX) > 45 && Math.abs(deltaX) > Math.abs(deltaY)) {
        var button = deltaX < 0 ? right : left;
        if (button) button.click();
      }
      x0 = y0 = null;
    }, { passive: true });

    /* --- ZOOM : lightbox sur la slide active --- */
    var box = document.createElement('div');
    box.className = 'strykr-zoom';
    // strykr-es-gallery-zoom-a11y-20260810
    const strykrEsZoomTemplates = [
      'strykr-einsatzhose-pro-live',
      'strykr-pro-motorrad-komfort-v1',
      'strykr-pro-komfort-fit-v1',
      'strykr-strasse',
      'strykr-strasse-fit',
      'strykr-strasse-proof'
    ];
    const strykrZoomSuffix = window._template && window._template.suffix;
    const strykrZoomCloseLabel = document.documentElement.lang.toLowerCase().startsWith('es')
      && strykrEsZoomTemplates.includes(strykrZoomSuffix) ? 'Cerrar' : 'Schließen';
    box.innerHTML = '<button class="strykr-zoom__close" type="button" aria-label="' + strykrZoomCloseLabel + '">×</button><img alt="">';
    document.body.appendChild(box);
    var zoomImage = box.querySelector('img');
    var suppressZoomClickUntil = 0;

    function activeMedia() {
      return frame.querySelector('.media-slide.active .media-asset');
    }

    function syncZoomImage() {
      var active = activeMedia();
      if (!active) return;
      zoomImage.src = active.dataset.src || active.currentSrc || active.src;
      zoomImage.alt = active.alt || '';
    }

    function syncAfterGalleryChange() {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(syncZoomImage);
      });
    }

    function navigate(direction) {
      var button = direction > 0 ? right : left;
      if (!button) return;
      box.classList.remove('zoomed');
      button.click();
      syncAfterGalleryChange();
    }

    if (enhanced && left && right) {
      box.dataset.galleryNavigation = 'true';
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');

      var previousButton = document.createElement('button');
      previousButton.className = 'strykr-zoom__nav strykr-zoom__nav--prev';
      previousButton.type = 'button';
      previousButton.setAttribute('aria-label', left.getAttribute('aria-label') || 'Previous image');
      previousButton.textContent = '‹';

      var nextButton = document.createElement('button');
      nextButton.className = 'strykr-zoom__nav strykr-zoom__nav--next';
      nextButton.type = 'button';
      nextButton.setAttribute('aria-label', right.getAttribute('aria-label') || 'Next image');
      nextButton.textContent = '›';

      box.appendChild(previousButton);
      box.appendChild(nextButton);
      previousButton.addEventListener('click', function () { navigate(-1); });
      nextButton.addEventListener('click', function () { navigate(1); });

      var zoomStartX = null;
      var zoomStartY = null;
      box.addEventListener('touchstart', function (event) {
        if (event.touches.length !== 1) {
          zoomStartX = zoomStartY = null;
          return;
        }
        zoomStartX = event.touches[0].clientX;
        zoomStartY = event.touches[0].clientY;
      }, { passive: true });
      box.addEventListener('touchend', function (event) {
        if (zoomStartX === null || !event.changedTouches.length) return;
        var deltaX = event.changedTouches[0].clientX - zoomStartX;
        var deltaY = event.changedTouches[0].clientY - zoomStartY;
        if (Math.abs(deltaX) > 45 && Math.abs(deltaX) > Math.abs(deltaY)) {
          suppressZoomClickUntil = Date.now() + 400;
          navigate(deltaX < 0 ? 1 : -1);
        }
        zoomStartX = zoomStartY = null;
      }, { passive: true });
      box.addEventListener('click', function (event) {
        if (event.target === zoomImage && Date.now() < suppressZoomClickUntil) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
    }

    frame.addEventListener('click', function (event) {
      if (event.target.closest('.gal-nav')) return;
      if (!activeMedia()) return;
      syncZoomImage();
      box.classList.add('open');
      document.body.style.overflow = 'hidden';
    });

    function close() {
      box.classList.remove('open', 'zoomed');
      document.body.style.overflow = '';
    }

    box.querySelector('.strykr-zoom__close').addEventListener('click', close);
    box.addEventListener('click', function (event) {
      if (event.target === box) close();
    });
    zoomImage.addEventListener('click', function () {
      box.classList.toggle('zoomed');
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        close();
        return;
      }
      if (!enhanced || !box.classList.contains('open')) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        navigate(event.key === 'ArrowRight' ? 1 : -1);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
